<template>
  <div class="empty-state">
    <div
      v-if="props.icon"
      class="mb-5 w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full flex-shrink-0"
    >
      <Icon
        :name="props.icon"
        class="w-8 h-auto text-gray-400"
      />
    </div>
    <h2 class="text-lg font-medium text-center">
      {{ props.title }}
    </h2>
    <p
      v-if="props.description"
      class="text-sm text-gray-500 text-center mt-1.5 max-w-[25rem]"
    >
      {{ props.description }}
    </p>

    <div class="mt-4">
      <slot />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  icon: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.empty-state {
  @apply rounded-xl flex flex-col justify-center items-center py-14 px-10;
}
</style>
